import React from 'react';

function DirectBuySell(props) {
    return (
        <div>
            <p>
                In this component, a business application with standard functionality to link
                a one-to-one farmer and buyer approach has been taken into consideration. It
                has been identified that there is a priority for isolated farmers in this function.
                The algorithm which was being used in this approach separates isolated farmers
                from groups of farmers and returns an Array list of farmer objects.
                In addition, large-scale buyers must get a farmer list based on the specifications provided. This approach could be achieved using the Spring Boot framework which is very much alike the procedure that happens in a Java environment.
                For both the methods, distance calculation formula was used to determine the
                distance between two points defined by latitude and longitude. For these methods, unit tests on sample farmer data sets were performed and received successful
                results.
                Through this GreenHub LK approach, we engage cultivators via the application and
                improve harvest profit by lowering the cost of the intermediary through the use of the direct buy and
                sell method for both small- and large-scale buyers and sellers .
            </p>
            <br/>
            <br/>
        </div>
    );
}

export default DirectBuySell;
